import { useTranslation } from "@/shared/providers/LanguageProvider";

type DarkPaymentCardClientProps = {
  card: PaymentCard;
};

export function DarkPaymentCardClient({ card }: DarkPaymentCardClientProps) {
  const { t } = useTranslation();

  return (
    <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-[#1e293b] to-[#0f172a] p-6 text-white">
      <div className="absolute -right-8 -top-8 h-32 w-32 rounded-full bg-white/5" />
      <div className="absolute -bottom-6 -left-6 h-24 w-24 rounded-full bg-white/5" />
      <div className="relative">
        <p className="text-xs font-medium text-white/60">{t.common.cardNumber}</p>
        <p className="mt-1 text-lg font-semibold tracking-widest">{card.cardNumber}</p>
        <div className="mt-8 flex items-end justify-between">
          <div>
            <p className="text-xs text-white/60">{t.common.balance}</p>
            <p className="text-xl font-bold">{card.balance}</p>
          </div>
          {card.brand && <p className="text-lg font-bold italic tracking-wider">{card.brand}</p>}
        </div>
      </div>
    </div>
  );
}
